// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b7aceac8","413":"143796d4","963":"d3cf52b6","988":"6486dff6"}[chunkId] + ".chunk.js";
};